export const SAMPLE_ORDER_EDITABLE_STATUSES = new Set(["1", "1_sent", "2", "3", "4"]);

export const SAMPLE_ORDER_UPFRONT_DISABLED_HELPER =
  "Upfront payment is disabled because this is a sample order.";

export const canEditSampleOrderStatus = (status) =>
  SAMPLE_ORDER_EDITABLE_STATUSES.has(String(status ?? "").trim());

export const getSampleOrderStageHelperText = (status) =>
  canEditSampleOrderStatus(status)
    ? "Mark this sales order as a sample order. Sample orders do not require a deposit or upfront payment."
    : "Sample order status cannot be changed at this stage.";

export const getSampleOrderDialogContent = (nextValue) =>
  nextValue
    ? {
        title: "Make This a Sample Order?",
        message:
          "This will mark the sales order as a sample order and immediately disable all deposit and upfront payment requirements. The customer will not be required to pay a deposit before the order can proceed.",
        confirmLabel: "Make Sample Order",
      }
    : {
        title: "Remove Sample Order Status?",
        message:
          "This sales order will return to the normal payment workflow. Review and configure its deposit or upfront payment requirements after continuing.",
        confirmLabel: "Remove Sample Status",
      };
